import './theme_demo.scss';
import ITheme from '../ITheme';
import NavigationItems from '@/navigationItems';

const isKeusote = window.location.hostname.includes('keusote') || window.location.hostname.includes('localhost');

export default class ThemeDemo implements ITheme {
    id: string = 'demo';
    matchIfHostNameContainsAny: string[] = ['demo', 'itauusimaa', 'keusote', '02', 'optigo.co.uk', 'optigo.us', 'etelapohjanmaa'];
    name: string = 'Demo';
    cssClassName: string = 'theme_demo';
    dark: boolean = false;
    menuDark: boolean = false;
    toolbarDark: boolean = true;
    bottomNavDark: boolean = true;
    menuRight: boolean = false;
    booking: boolean = true;
    menuNavigationItems: INavigationItem[] = [
        NavigationItems.passengers,
        NavigationItems.passengerTransportationPermissions,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.booking,
        NavigationItems.personalInfo,
        NavigationItems.messages,
        isKeusote ? NavigationItems.accessibilityReportKeusote : NavigationItems.accessibilityReport,
        isKeusote ? NavigationItems.privacyKeusote : NavigationItems.privacy,
    ];
    bottomNavNavigationItems: INavigationItem[] = [
        NavigationItems.booking,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.messages,
    ];
    vuetifyTheme: any = {
        primary: '#000000',
        secondary: '#FFD700',
        accent: 'FFD700',
        warning: 'FFD700',
        error: "#eb1111",
        red: "#e91b0c",
        grey: "#767676",
        bottomNavColor: '#ffffff'
    };
}
